import { Component, Input, OnInit } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase,ForAtylInputBase } from '../../../../form-atyl-base'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { SelectionService } from '../../../../../services'
import { AtylService } from '../../../../service/atyl.service'

@Component({
	selector: 'atyl-form-input-list',
	templateUrl: './form-input-list.component.html',
	styleUrls: ['./form-input-list.component.scss']
})
export class FormInputListComponent extends ForAtylInputBase implements OnInit {

	@Input() forminput: FormAtylBase<any> = null
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() disabled: boolean

	label: string
	errorString: string
	@Input() outline: any

	constructor(
		private listService: SelectionService,
		private readonly inputLabelPipe: InputLabelPipe,
		private atylService: AtylService,
	) {
		super();
	}

	ngOnInit(): void {
		
		// get options list from webservice
		/*
		{
			    "typelist": "Ecole",
			    "fields": {
			        "value":"id",
			        "label":["tiers.tiersMorale.nom",
			                    "tiers.tiersAdresse.0.adresse.ville.libelle"]
			    },
			    "values":[]
			}
		*/
		if (this.forminput 
			&& this.forminput.options['typelist']!=undefined
			&& this.forminput.options['fields']!=undefined
		) {
			console.log("FormInputDropDownComponent list",
			this.forminput.options['typelist'],
			this.forminput.options['fields']
			);
			
			let _ops={}
			
			if (this.forminput.options['options'])
			    _ops=this.forminput.options['options'];
			this.emitReadyEvent(false,this.forminput);
			this.atylService.getListeSelectionOPtion(this.forminput.options['typelist'], _ops).subscribe((res: JSONRpcResponse) => {
				//console.log("FormInputDropDownComponent list result",res.result);
				if (res.result.datas!=undefined && res.result.datas.datas!=undefined) {
					let lines=res.result.datas.datas;
					if (lines.length>0
						&& this.forminput.options['fields']["value"]!=undefined
					) {
						let col_val:string="id"
						if (this.forminput.options['fields']["value"]!=undefined)
							col_val=this.forminput.options['fields']["value"];
						let cols_label:string[] =["label"]
						if (this.forminput.options['fields']["label"]!=undefined)
							cols_label=this.forminput.options['fields']["label"];	
						//console.log("FormInputDropDownComponent  result parse",col_val,cols_label,lines)
						for(let i=0;i<lines.length;i++) {
							let l=lines[i];
							let val={
								value:null,
								label:null
							}
							if (l[col_val]!=undefined)
							    val["value"]=l[col_val];
							if (this.forminput.options['fields']["template"]=undefined) {
								
								let tpl:string=this.forminput.options['fields']["template"];
								for(let lb=0;lb<cols_label.length;lb++) {
									if (l[cols_label[lb]]!=undefined)
								    	tpl=tpl.replace("{{"+cols_label[lb]+"}}", l[cols_label[lb]]);
								    else
								    	tpl=tpl.replace("{{"+cols_label[lb]+"}}", "");	
								}
								val["label"]=tpl;
							} else {
								let lbs=[];
								for(let lb=0;lb<cols_label.length;lb++) {
									if (l[cols_label[lb]]!=undefined)
								    	lbs.push(l[cols_label[lb]]);
								}
								val["label"]=lbs.join(" ");
							}
							this.forminput.options.values.push(val)
							
						}
						console.log("FormInputDropDownComponent  result",
						res.result,
						this.forminput.options.values)
						
				    }
				}
				this.emitReadyEvent(true,this.forminput);
			})
		}
		
		// labelize
		this.label = this.inputLabelPipe.transform(this.forminput)
		// error message
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}

}
